import React, { useEffect, useState, useRef } from 'react';
import {
  AiOutlinePlusCircle,
  AiOutlineDelete,
  AiOutlineEdit, AiOutlineCheck, AiOutlineClose
} from 'react-icons/ai';
import Select from 'react-select';
import axios from 'axios';
import { Modal, Button, Table, Form } from "react-bootstrap";
import { CiEdit } from 'react-icons/ci';
import { MdLocalPrintshop } from "react-icons/md";
import logo from '../../../assets/logo.png'
import { useLocation } from 'react-router-dom';
import { useLoading } from '../../../context/LoadingContext';
import ToastNotification from '../../../components/ToastNotification';

function AppraisalType() {

  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [user, setUser] = useState([]);
  const { setLoading } = useLoading();
    const [parameter, setParameter] = useState([]);
     const [rating, setRating] = useState([]);
       const [type, setType] = useState([]);
       const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [formItems, setFormItems] = useState({
    name: '',
   
  })


  const [showOptionModal, setShowOptionModal] = useState(false);
  const [newOptionValue, setNewOptionValue] = useState("");
  const [activeDropdown, setActiveDropdown] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };

  const [rows, setRows] = useState([
  {
    parameterId: "",
    parameterName: "",
    order: ""
  }
]);

const [ratingRows, setRatingRows] = useState([
  {
    ratingId: "",
    ratingName: "",
    order: ""
  }
]);

 const handleAddRow = () => {
  setRows((prev) => [
    ...prev,
    {
      parameterId: "",
      parameterName: "",
      order: ""
    }
  ]);
};
  const handleDeleteRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

const handleRowChange = (index, field, value) => {
  setRows((prev) =>
    prev.map((row, i) =>
      i === index
        ? { ...row, [field]: value }
        : row
    )
  );
};
const handleAddRatingRow = () => {
  setRatingRows((prev) => [
    ...prev,
    {
      ratingId: "",
      ratingName: "",
      order: ""
    }
  ]);
};

const handleDeleteRatingRow = (index) => {
  setRatingRows((prev) =>
    prev.filter((_, i) => i !== index)
  );
};

const handleRatingRowChange = (index, field, value) => {
  setRatingRows((prev) =>
    prev.map((row, i) =>
      i === index
        ? { ...row, [field]: value }
        : row
    )
  );
};
  



  const handleFormOpen = () => {
    setShowForm(true);
  }


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormItems(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const [sourceOptions, setSourceOptions] = useState([
                  { value: "Adaptabilty/Flexibility", label: "Adaptabilty/Flexibility" },
                  { value: "Decision Making/Judgement", label: "Decision Making/Judgement" },
                  { value: "Communication", label: "Communication" }
                ]);




  const fectparameter = async () => {
    setLoading(true)
    try {
      const res = await axios.get('https://api.skyguard.group/api/fetch-parameter');
      setParameter(res.data);

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };


const parameterOptions = parameter.map((item) => ({
  id: item.id,
  value: item.id,
  label: item.name
}));

  const fetchRating = async () => {
    setLoading(true)
    try {
      const res = await axios.get('https://api.skyguard.group/api/fetch-rating');
      setRating(res.data);

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

   const fetchType = async () => {
    setLoading(true)
    try {
      const res = await axios.get('https://api.skyguard.group/api/fetch-appraisal-type');
      setType(res.data);

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

  const ratingOptions = rating.map((item) => ({
  value: item.value,
  label: item.name,
  id: item.id
}));

  useEffect(() => {
    fectparameter();
fetchRating();
fetchType();
  }, []);


const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = {
    name: formItems.name,
    parameter_row: rows,
    rating_row: ratingRows
  };



  if (isEditMode) {
    try {
      const res = await axios.put(
        `https://api.skyguard.group/api/update-appraisal-type/${formItems.id}`,
        payload
      );

      showToast("Appraisal Type updated successfully!", "success");

      setShowForm(false);
      setIsEditMode(false);

      setFormItems({
        name: "",
        parameter_row: "",
        rating_row: ""
      });

      setRows([
        { col1: "", col2: "" }
      ]);

   setRatingRows([
  {
    ratingId: "",
    ratingName: "",
    order: ""
  }
]);

   fetchType();
    } catch (err) {
      showToast("Failed to update appraisal type!", "danger");
      console.error(err.response?.data || err.message);
    }
  } else {
    try {
      const res = await axios.post(
        "https://api.skyguard.group/api/add-appraisal-type",
        payload
      );

      showToast("Appraisal Type added successfully!", "success");

      setShowForm(false);

      setFormItems({
        name: "",
        parameter_row: "",
        rating_row: ""
      });

      setRows([
        { col1: "", col2: "" }
      ]);

      setRatingRows([
  {
    ratingId: "",
    ratingName: "",
    order: ""
  }
]);

     fetchType();
    } catch (err) {
      showToast("Failed to add appraisal type!", "danger");
      console.error(err.response?.data || err.message);
    }
  }
};

const handleEdit = (form) => {
  setFormItems({
    id: form.id || "",
    name: form.name || ""
  });

  setRows(
    Array.isArray(form.parameter_row)
      ? form.parameter_row
      : JSON.parse(form.parameter_row || "[]")
  );

  setRatingRows(
    Array.isArray(form.rating_row)
      ? form.rating_row
      : JSON.parse(form.rating_row || "[]")
  );

  setIsEditMode(true);
  setShowForm(true);
};

      const filteredData = type.filter(itm =>
    Object.values(itm).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  )


  return (
      <div className='main-section'>
      <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
        <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />
        <h3 className='my-3 fw-bold fs-5 golos'>Appraisal Type</h3>
        <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
          <div className="col-12 col-md-5">
            <input
              type="text"
              className="form-control border-0 border-bottom border-dark"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="col-12 col-md-2 d-flex justify-content-end">
            <button className='btn btn-success' onClick={handleFormOpen}>
              <AiOutlinePlusCircle size={20} /> Add
            </button>
          </div>
        </div>

        {showForm && (
          <div className="card p-3 my-3 shadow-sm bg-white border">
            <form onSubmit={handleSubmit}>
              <div className="row">

                <div className='col-12'>
                  <div className="row g-3">

                    <div className="col-12 col-md-4">
                      <label className="form-label fw-medium">Name</label>
                      <input
                        name="name"
                        className="form-control w-100"
                        placeholder="Enter parameter name"
                        value={formItems.name}
                        onChange={handleChange}
                      />

                    </div>


<div className="row mt-3">

  {/* First Table */}
  <div className="col-md-6">

    <div className="d-flex justify-content-start mb-2">
      <button
        type="button"
        className="btn btn-sm btn-primary"
        onClick={handleAddRow}
      >
        + Add Row
      </button>
    </div>

    <div className="table-responsive">
      <table className="table table-bordered">
        <thead className="table-info">
          <tr>
            <th>Parameter</th>
            <th width="120">Order</th>
            <th width="120">Action</th>
          </tr>
        </thead>

        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              <td>
  <Select
  options={parameterOptions}
  value={
    parameterOptions.find(
      (opt) => opt.value === row.parameterId
    ) || null
  }
  onChange={(selected) =>
    setRows((prev) =>
      prev.map((r, i) =>
        i === index
          ? {
              ...r,
              parameterId: selected?.value || "",
              parameterName: selected?.label || ""
            }
          : r
      )
    )
  }
  menuPortalTarget={document.body}
  styles={{
    container: (base) => ({
      ...base,
      width: "100%"
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999
    })
  }}
/>
              </td>

              <td>
                <input
  type="text"
  className="form-control"
  value={row.order}
  onChange={(e) =>
    handleRowChange(
      index,
      "order",
      e.target.value
    )
  }
/>
              </td>

              <td className="text-center">
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() => handleDeleteRow(index)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

  </div>

  {/* Second Table */}
  <div className="col-md-6">

  <div className="d-flex justify-content-start mb-2">
    <button
      type="button"
      className="btn btn-sm btn-primary"
      onClick={handleAddRatingRow}
    >
      + Add Row
    </button>
  </div>

  <div className="table-responsive">
    <table className="table table-bordered">
      <thead className="table-info">
        <tr>
          <th>Rating</th>
          <th width="120">Order</th>
          <th width="120">Action</th>
        </tr>
      </thead>

      <tbody>
        {ratingRows.map((row, index) => (
          <tr key={index}>
          
             <td>
 <Select
  options={ratingOptions}
  value={
    ratingOptions.find(
      (opt) => opt.id === row.ratingId
    ) || null
  }
  onChange={(selected) =>
    setRatingRows((prev) =>
      prev.map((r, i) =>
        i === index
          ? {
              ...r,
              ratingId: selected.id,
              ratingName: selected.label,
              order: selected.value
            }
          : r
      )
    )
  }
  placeholder="Select Rating"
   menuPortalTarget={document.body}
  styles={{
    container: (base) => ({
      ...base,
      width: "100%"
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999
    })
  }}
/>
</td>
        
<td>
  <input
    type="text"
    className="form-control"
    value={row.order}
    disabled
  />
</td>

            <td className="text-center">
              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={() =>
                  handleDeleteRatingRow(index)
                }
              >
                Delete
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

</div>

</div>
               

                  </div>
                </div>


                <div className='gap-2 d-flex justify-content-center mt-4'>
                  <button type="submit" className='btn btn-success w-10'>
                    {isEditMode ? "Update" : "Save"}

                  </button>
                  <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                    setShowForm(false);

                  }}>
                    Cancel
                  </button>
                </div>


              </div>
            </form>
          </div>

        )}


        <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
          <table className='table table-bordered table-striped table-hover text-center align-middle'>
            <thead className='table-info'>
              <tr>
                <th scope='col'>SN </th>
                  <th scope='col' >Action</th>
                <th scope='col' >Name</th>
             
              </tr>
            </thead>

              {filteredData.map((acc, idx) => (
                <tr key={idx} >
                     <td>{idx + 1}</td>
                    <td> 
                       <button
                    className="btn btn-success"
                   
                    onClick={() => handleEdit(acc)}
                  >
                    <CiEdit size={20} />
                  </button>
                  </td>
                  <td> {acc.name} </td>
        
                </tr>
              ))}
          </table>
        </div>


 
      </div>
    </div>
  )
}

export default AppraisalType